/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Other
 *
 * 1 = Parts
 *
 * 2 = ServiceSchedule
 *
 * 3 = Recall
 *
 * 4 = CIF
 */
export enum WipServicePdfTypeEnum {
  Other = 0,
  Parts = 1,
  ServiceSchedule = 2,
  Recall = 3,
  CIF = 4,
}
